"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from "react";
import { cleanProps, cn } from "../../../utils/index.js";
import { Popover } from "../../Popover/index.js";
import { NonOpenableFilterChip } from "./NonOpenableFilterChip.js";
const OpenableFilterChip_OpenableFilterChip = /*#__PURE__*/ forwardRef(function({ children, isOpen: isOpenProp, open: openAlias, onOpenChange, defaultOpen, headingText, description, showArrow = false, side = 'bottom', align = 'center', positionerOffset = 8, onClose, openOnHover = false, popoverSize = 'md', slotClassNames: _slotClassNames, disableTriggerFocus: _disableTriggerFocus, ariaLabel: _ariaLabel, title: _title, ...props }, ref) {
    const isOpen = isOpenProp ?? openAlias;
    const [internalIsOpen, setInternalIsOpen] = useState(defaultOpen ?? false);
    const isControlled = void 0 !== isOpen;
    const currentIsOpen = isControlled ? isOpen : internalIsOpen;
    const { label, helperText, className, id, name, disabled, onClick, selected, onSelectionChange, iconLeft, customIcon, value, count, filterType, type, elevated, emphasis, showCheckIcon, customNode } = props;
    useEffect(()=>{
        if (isControlled && void 0 !== isOpen) setInternalIsOpen(isOpen);
    }, [
        isControlled,
        isOpen
    ]);
    const handleOpenChange = (open)=>{
        if (!isControlled) setInternalIsOpen(open);
        onOpenChange?.(open);
        if (!open) onClose?.();
    };
    const nonOpenableChipProps = {
        label,
        helperText,
        id,
        name,
        disabled,
        onClick,
        selected,
        onSelectionChange,
        iconLeft,
        customIcon,
        value,
        count,
        filterType,
        type,
        elevated,
        emphasis,
        showCheckIcon,
        customNode
    };
    const triggerNode = /*#__PURE__*/ jsx(NonOpenableFilterChip, {
        ref: ref,
        ...cleanProps(nonOpenableChipProps, []),
        className: cn(className, 'openable-filter-chip')
    });
    return /*#__PURE__*/ jsxs(Popover.Root, {
        open: currentIsOpen,
        onOpenChange: handleOpenChange,
        children: [
            /*#__PURE__*/ jsx(Popover.Trigger, {
                openOnHover: openOnHover,
                render: triggerNode
            }),
            /*#__PURE__*/ jsx(Popover.Portal, {
                children: /*#__PURE__*/ jsx(Popover.Positioner, {
                    side: side,
                    align: align,
                    sideOffset: positionerOffset,
                    children: /*#__PURE__*/ jsxs(Popover.Popup, {
                        size: popoverSize,
                        children: [
                            showArrow && /*#__PURE__*/ jsx(Popover.Arrow, {}),
                            headingText && /*#__PURE__*/ jsx(Popover.Title, {
                                children: headingText
                            }),
                            description && /*#__PURE__*/ jsx(Popover.Description, {
                                children: description
                            }),
                            children
                        ]
                    })
                })
            })
        ]
    });
});
OpenableFilterChip_OpenableFilterChip.displayName = 'OpenableFilterChip';
export { OpenableFilterChip_OpenableFilterChip as OpenableFilterChip };
